var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    xmlnsv: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.725c-.675.3-1.35.525-2.1.6.75-.45 1.35-1.2 1.65-2.025-.75.45-1.5.75-2.325.9a3.63 3.63 0 0 0-2.7-1.2A3.68 3.68 0 0 0 8.85 3.675c0 .3 0 .6.075.825-3.15-.15-5.85-1.65-7.65-3.9C.9 1.2.75 1.8.75 2.475c0 1.275.675 2.4 1.65 3.075-.6 0-1.2-.15-1.65-.45v.075c0 1.8 1.275 3.3 2.925 3.6-.3.075-.6.15-.975.15-.225 0-.45 0-.675-.075.45 1.5 1.8 2.55 3.45 2.55-1.275.975-2.85 1.575-4.575 1.575-.3 0-.6 0-.9-.075 1.65 1.05 3.6 1.65 5.625 1.65 6.825 0 10.5-5.625 10.5-10.5V3.6c.75-.525 1.35-1.2 1.875-1.875z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.0b2b5f536145afdb63e2a656a58dc161.svg";
export { ForwardRef as ReactComponent };